import * as _ from 'lodash';
import { AsyncRequestStatus, getDefaultAsyncWrapperObj } from '@ane/core/lib/models';
import { defaultReducerState, IReducerKeys, loadMetricsAnalysisTemplateEpicReducer, } from './ProgressionScorecard.ducks';
export const setMetricsAnalysisTemplatesInReduxWhenLoading = (state = defaultReducerState(), input) => {
    var _a;
    let returnObj = Object.assign({}, state[IReducerKeys.metrics_analysis_template_data]);
    const templates = _.split((_a = input === null || input === void 0 ? void 0 : input.templateName) !== null && _a !== void 0 ? _a : '', ',');
    _.forEach(templates, (templateName) => {
        var _a, _b, _c;
        returnObj = Object.assign(Object.assign({}, returnObj), { [templateName]: {
                [IReducerKeys.analysis_template_async]: Object.assign(Object.assign({}, ((_c = (_b = (_a = state === null || state === void 0 ? void 0 : state[IReducerKeys.metrics_analysis_template_data]) === null || _a === void 0 ? void 0 : _a[input.templateName]) === null || _b === void 0 ? void 0 : _b[IReducerKeys.analysis_template_async]) !== null && _c !== void 0 ? _c : getDefaultAsyncWrapperObj())), { status: AsyncRequestStatus.Pending }),
            } });
    });
    return returnObj;
};
export const getUnavailableTemplateMessage = (template) => `Cannot load ${template}. \
This means that at least one analysis was not registered successfully for your experiment. \
Please verify that the template is valid and spelled correctly (case sensitive) in the Analysis Config section \
for your Experimentation Group. To update the config, reach out to your experiment champ (aka.ms/exp/ada/support).`;
export const setMetricsAnalysisTemplatesInReduxWhenLoaded = (state = defaultReducerState(), resultTemplates, asyncData) => {
    let returnObj = Object.assign({}, state[IReducerKeys.metrics_analysis_template_data]);
    _.forEach(resultTemplates, (template) => {
        returnObj = Object.assign(Object.assign({}, returnObj), { [template.name]: { [IReducerKeys.analysis_template_async]: Object.assign(Object.assign({}, asyncData), { data: template }) } });
    });
    // For templates that are never returned from Metrics API, set their status as Failed.
    let availableTemplateNames = resultTemplates.map((rt) => rt.name);
    let requestedTemplateNames = Object.keys(returnObj);
    let unavailableTemplateNames = requestedTemplateNames.filter((requestedTemplate) => !availableTemplateNames.includes(requestedTemplate));
    _.forEach(unavailableTemplateNames, (unavailableTemplateName) => {
        returnObj = Object.assign(Object.assign({}, returnObj), { [unavailableTemplateName]: {
                [IReducerKeys.analysis_template_async]: {
                    status: AsyncRequestStatus.Failed,
                    data: null,
                    error: getUnavailableTemplateMessage(unavailableTemplateName),
                },
            } });
    });
    return returnObj;
};
export const afterLoadAnalysisConfigActions = (AnalysisConfig, workspaceId) => {
    const templateNamesRaw = _.uniq(_.map(AnalysisConfig === null || AnalysisConfig === void 0 ? void 0 : AnalysisConfig.AnalysisRules, (rule) => rule.SelectedAnalysisTemplates).flat());
    const templateNames = _.reject(templateNamesRaw, _.isNil);
    const optInTemplateNamesRaw = _.uniq(_.map(AnalysisConfig === null || AnalysisConfig === void 0 ? void 0 : AnalysisConfig.OptInAnalysisTemplates, (template) => template).flat());
    const optInTemplateNames = _.reject(optInTemplateNamesRaw, _.isNil);
    const optOutTemplateNamesRaw = _.uniq(_.map(AnalysisConfig === null || AnalysisConfig === void 0 ? void 0 : AnalysisConfig.OptOutAnalysisTemplates, (template) => template).flat());
    const optOutTemplateNames = _.reject(optOutTemplateNamesRaw, _.isNil);
    const optInAnalysisRulesTemplateNamesRaw = _.uniq(_.map(AnalysisConfig === null || AnalysisConfig === void 0 ? void 0 : AnalysisConfig.OptInAnalysisRules, (rule) => rule.SelectedAnalysisTemplates).flat());
    const optInAnalysisRulesTemplateNames = _.reject(optInAnalysisRulesTemplateNamesRaw, _.isNil);
    const optOutAnalysisRulesTemplateNamesRaw = _.uniq(_.map(AnalysisConfig === null || AnalysisConfig === void 0 ? void 0 : AnalysisConfig.OptOutAnalysisRules, (rule) => rule.SelectedAnalysisTemplates).flat());
    const optOutAnalysisRulesTemplateNames = _.reject(optOutAnalysisRulesTemplateNamesRaw, _.isNil);
    const allTemplateNames = _.uniq([
        ...templateNames,
        ...optInTemplateNames,
        ...optOutTemplateNames,
        ...optInAnalysisRulesTemplateNames,
        ...optOutAnalysisRulesTemplateNames,
    ]);
    const templateNamesString = allTemplateNames.join(',');
    return [loadMetricsAnalysisTemplateEpicReducer.actionCreators.load({ templateName: templateNamesString, workspaceId })];
};

//# sourceMappingURL=ProgressionScorecard.ducks.utils.js.map
